// This file was generated by a custom prisma generator, do not edit manually.
export const SchedulingType = {
  ROUND_ROBIN: "ROUND_ROBIN",
  COLLECTIVE: "COLLECTIVE",
  MANAGED: "MANAGED",
} as const;

export type SchedulingType = (typeof SchedulingType)[keyof typeof SchedulingType];

export const PeriodType = {
  UNLIMITED: "UNLIMITED",
  ROLLING: "ROLLING",
  ROLLING_WINDOW: "ROLLING_WINDOW",
  RANGE: "RANGE",
} as const;

export type PeriodType = (typeof PeriodType)[keyof typeof PeriodType];

export const CreationSource = {
  API_V1: "API_V1",
  API_V2: "API_V2",
  WEBAPP: "WEBAPP",
} as const;

export type CreationSource = (typeof CreationSource)[keyof typeof CreationSource];

export const CancellationReasonRequirement = {
  MANDATORY_BOTH: "MANDATORY_BOTH",
  MANDATORY_HOST_ONLY: "MANDATORY_HOST_ONLY",
  MANDATORY_ATTENDEE_ONLY: "MANDATORY_ATTENDEE_ONLY",
  OPTIONAL_BOTH: "OPTIONAL_BOTH",
} as const;

export type CancellationReasonRequirement = (typeof CancellationReasonRequirement)[keyof typeof CancellationReasonRequirement];

export const IdentityProvider = {
  CAL: "CAL",
  GOOGLE: "GOOGLE",
  SAML: "SAML",
  AZUREAD: "AZUREAD",
  SEIBERT: "SEIBERT",
} as const;

export type IdentityProvider = (typeof IdentityProvider)[keyof typeof IdentityProvider];

export const UserPermissionRole = {
  USER: "USER",
  ADMIN: "ADMIN",
} as const;

export type UserPermissionRole = (typeof UserPermissionRole)[keyof typeof UserPermissionRole];

export const CreditUsageType = {
  SMS: "SMS",
  CAL_AI_PHONE_CALL: "CAL_AI_PHONE_CALL",
} as const;

export type CreditUsageType = (typeof CreditUsageType)[keyof typeof CreditUsageType];

export const CreditType = {
  MONTHLY: "MONTHLY",
  ADDITIONAL: "ADDITIONAL",
} as const;

export type CreditType = (typeof CreditType)[keyof typeof CreditType];

export const MembershipRole = {
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
  OWNER: "OWNER",
} as const;

export type MembershipRole = (typeof MembershipRole)[keyof typeof MembershipRole];

export const BookingStatus = {
  CANCELLED: "CANCELLED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  AWAITING_HOST: "AWAITING_HOST",
} as const;

export type BookingStatus = (typeof BookingStatus)[keyof typeof BookingStatus];

export const EventTypeCustomInputType = {
  TEXT: "TEXT",
  TEXTLONG: "TEXTLONG",
  NUMBER: "NUMBER",
  BOOL: "BOOL",
  RADIO: "RADIO",
  PHONE: "PHONE",
} as const;

export type EventTypeCustomInputType = (typeof EventTypeCustomInputType)[keyof typeof EventTypeCustomInputType];

export const ReminderType = {
  PENDING_BOOKING_CONFIRMATION: "PENDING_BOOKING_CONFIRMATION",
} as const;

export type ReminderType = (typeof ReminderType)[keyof typeof ReminderType];

export const PaymentOption = {
  ON_BOOKING: "ON_BOOKING",
  HOLD: "HOLD",
} as const;

export type PaymentOption = (typeof PaymentOption)[keyof typeof PaymentOption];

export const WebhookTriggerEvents = {
  BOOKING_CREATED: "BOOKING_CREATED",
  BOOKING_PAYMENT_INITIATED: "BOOKING_PAYMENT_INITIATED",
  BOOKING_PAID: "BOOKING_PAID",
  BOOKING_RESCHEDULED: "BOOKING_RESCHEDULED",
  BOOKING_REQUESTED: "BOOKING_REQUESTED",
  BOOKING_CANCELLED: "BOOKING_CANCELLED",
  BOOKING_REJECTED: "BOOKING_REJECTED",
  BOOKING_NO_SHOW_UPDATED: "BOOKING_NO_SHOW_UPDATED",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  MEETING_ENDED: "MEETING_ENDED",
  MEETING_STARTED: "MEETING_STARTED",
  RECORDING_READY: "RECORDING_READY",
  RECORDING_TRANSCRIPTION_GENERATED: "RECORDING_TRANSCRIPTION_GENERATED",
  OOO_CREATED: "OOO_CREATED",
  AFTER_HOSTS_CAL_VIDEO_NO_SHOW: "AFTER_HOSTS_CAL_VIDEO_NO_SHOW",
  AFTER_GUESTS_CAL_VIDEO_NO_SHOW: "AFTER_GUESTS_CAL_VIDEO_NO_SHOW",
  FORM_SUBMITTED_NO_EVENT: "FORM_SUBMITTED_NO_EVENT",
  DELEGATION_CREDENTIAL_ERROR: "DELEGATION_CREDENTIAL_ERROR",
  WRONG_ASSIGNMENT_REPORT: "WRONG_ASSIGNMENT_REPORT",
} as const;

export type WebhookTriggerEvents = (typeof WebhookTriggerEvents)[keyof typeof WebhookTriggerEvents];

export const AppCategories = {
  calendar: "calendar",
  messaging: "messaging",
  other: "other",
  payment: "payment",
  video: "video",
  web3: "web3",
  automation: "automation",
  analytics: "analytics",
  conferencing: "conferencing",
  crm: "crm",
} as const;

export type AppCategories = (typeof AppCategories)[keyof typeof AppCategories];

export const TimeUnit = {
  DAY: "DAY",
  HOUR: "HOUR",
  MINUTE: "MINUTE",
} as const;

export type TimeUnit = (typeof TimeUnit)[keyof typeof TimeUnit];

export const FeatureType = {
  RELEASE: "RELEASE",
  EXPERIMENT: "EXPERIMENT",
  OPERATIONAL: "OPERATIONAL",
  KILL_SWITCH: "KILL_SWITCH",
  PERMISSION: "PERMISSION",
} as const;

export type FeatureType = (typeof FeatureType)[keyof typeof FeatureType];

export const RRResetInterval = {
  MONTH: "MONTH",
  DAY: "DAY",
} as const;

export type RRResetInterval = (typeof RRResetInterval)[keyof typeof RRResetInterval];

export const RRTimestampBasis = {
  CREATED_AT: "CREATED_AT",
  START_TIME: "START_TIME",
} as const;

export type RRTimestampBasis = (typeof RRTimestampBasis)[keyof typeof RRTimestampBasis];

export const OAuthClientType = {
  CONFIDENTIAL: "CONFIDENTIAL",
  PUBLIC: "PUBLIC",
} as const;

export type OAuthClientType = (typeof OAuthClientType)[keyof typeof OAuthClientType];

export const OAuthClientStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;

export type OAuthClientStatus = (typeof OAuthClientStatus)[keyof typeof OAuthClientStatus];

export const AccessScope = {
  READ_BOOKING: "READ_BOOKING",
  READ_PROFILE: "READ_PROFILE",
} as const;

export type AccessScope = (typeof AccessScope)[keyof typeof AccessScope];

export const RedirectType = {
  UserEventType: "UserEventType",
  TeamEventType: "TeamEventType",
  User: "User",
  Team: "Team",
} as const;

export type RedirectType = (typeof RedirectType)[keyof typeof RedirectType];

export const SMSLockState = {
  LOCKED: "LOCKED",
  UNLOCKED: "UNLOCKED",
  REVIEW_NEEDED: "REVIEW_NEEDED",
} as const;

export type SMSLockState = (typeof SMSLockState)[keyof typeof SMSLockState];

export const AttributeType = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  SINGLE_SELECT: "SINGLE_SELECT",
  MULTI_SELECT: "MULTI_SELECT",
} as const;

export type AttributeType = (typeof AttributeType)[keyof typeof AttributeType];

export const AssignmentReasonEnum = {
  REASSIGNED: "REASSIGNED",
  RR_REASSIGNED: "RR_REASSIGNED",
  REROUTED: "REROUTED",
  SALESFORCE_ASSIGNMENT: "SALESFORCE_ASSIGNMENT",
} as const;

export type AssignmentReasonEnum = (typeof AssignmentReasonEnum)[keyof typeof AssignmentReasonEnum];

export const EventTypeAutoTranslatedField = {
  DESCRIPTION: "DESCRIPTION",
  TITLE: "TITLE",
} as const;

export type EventTypeAutoTranslatedField = (typeof EventTypeAutoTranslatedField)[keyof typeof EventTypeAutoTranslatedField];

export const WatchlistType = {
  EMAIL: "EMAIL",
  DOMAIN: "DOMAIN",
  USERNAME: "USERNAME",
} as const;

export type WatchlistType = (typeof WatchlistType)[keyof typeof WatchlistType];

export const WatchlistAction = {
  REPORT: "REPORT",
  BLOCK: "BLOCK",
  ALERT: "ALERT",
} as const;

export type WatchlistAction = (typeof WatchlistAction)[keyof typeof WatchlistAction];

export const WatchlistSource = {
  MANUAL: "MANUAL",
  FREE_DOMAIN_POLICY: "FREE_DOMAIN_POLICY",
  SIGNUP: "SIGNUP",
} as const;

export type WatchlistSource = (typeof WatchlistSource)[keyof typeof WatchlistSource];

export const BookingReportReason = {
  SPAM: "SPAM",
  DONT_KNOW_PERSON: "DONT_KNOW_PERSON",
  OTHER: "OTHER",
} as const;

export type BookingReportReason = (typeof BookingReportReason)[keyof typeof BookingReportReason];

export const BookingReportStatus = {
  PENDING: "PENDING",
  DISMISSED: "DISMISSED",
  BLOCKED: "BLOCKED",
} as const;

export type BookingReportStatus = (typeof BookingReportStatus)[keyof typeof BookingReportStatus];

export const SystemReportStatus = {
  PENDING: "PENDING",
  BLOCKED: "BLOCKED",
  DISMISSED: "DISMISSED",
} as const;

export type SystemReportStatus = (typeof SystemReportStatus)[keyof typeof SystemReportStatus];

export const WrongAssignmentReportStatus = {
  PENDING: "PENDING",
  REVIEWED: "REVIEWED",
  RESOLVED: "RESOLVED",
  DISMISSED: "DISMISSED",
} as const;

export type WrongAssignmentReportStatus = (typeof WrongAssignmentReportStatus)[keyof typeof WrongAssignmentReportStatus];

export const BillingPeriod = {
  MONTHLY: "MONTHLY",
  ANNUALLY: "ANNUALLY",
} as const;

export type BillingPeriod = (typeof BillingPeriod)[keyof typeof BillingPeriod];

export const BillingMode = {
  SEATS: "SEATS",
  ACTIVE_USERS: "ACTIVE_USERS",
} as const;

export type BillingMode = (typeof BillingMode)[keyof typeof BillingMode];

export const FilterSegmentScope = {
  USER: "USER",
  TEAM: "TEAM",
} as const;

export type FilterSegmentScope = (typeof FilterSegmentScope)[keyof typeof FilterSegmentScope];

export const RoleType = {
  SYSTEM: "SYSTEM",
  CUSTOM: "CUSTOM",
} as const;

export type RoleType = (typeof RoleType)[keyof typeof RoleType];

export const BookingAuditType = {
  RECORD_CREATED: "RECORD_CREATED",
  RECORD_UPDATED: "RECORD_UPDATED",
  RECORD_DELETED: "RECORD_DELETED",
} as const;

export type BookingAuditType = (typeof BookingAuditType)[keyof typeof BookingAuditType];

export const BookingAuditAction = {
  CREATED: "CREATED",
  CANCELLED: "CANCELLED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  AWAITING_HOST: "AWAITING_HOST",
  RESCHEDULED: "RESCHEDULED",
  ATTENDEE_ADDED: "ATTENDEE_ADDED",
  ATTENDEE_REMOVED: "ATTENDEE_REMOVED",
  REASSIGNMENT: "REASSIGNMENT",
  LOCATION_CHANGED: "LOCATION_CHANGED",
  NO_SHOW_UPDATED: "NO_SHOW_UPDATED",
  RESCHEDULE_REQUESTED: "RESCHEDULE_REQUESTED",
  SEAT_BOOKED: "SEAT_BOOKED",
  SEAT_RESCHEDULED: "SEAT_RESCHEDULED",
} as const;

export type BookingAuditAction = (typeof BookingAuditAction)[keyof typeof BookingAuditAction];

export const BookingAuditSource = {
  API_V1: "API_V1",
  API_V2: "API_V2",
  WEBAPP: "WEBAPP",
  WEBHOOK: "WEBHOOK",
  SYSTEM: "SYSTEM",
  MAGIC_LINK: "MAGIC_LINK",
  UNKNOWN: "UNKNOWN",
} as const;

export type BookingAuditSource = (typeof BookingAuditSource)[keyof typeof BookingAuditSource];

export const AuditActorType = {
  USER: "USER",
  GUEST: "GUEST",
  ATTENDEE: "ATTENDEE",
  SYSTEM: "SYSTEM",
  APP: "APP",
} as const;

export type AuditActorType = (typeof AuditActorType)[keyof typeof AuditActorType];

export const PhoneNumberSubscriptionStatus = {
  ACTIVE: "ACTIVE",
  PAST_DUE: "PAST_DUE",
  CANCELLED: "CANCELLED",
  INCOMPLETE: "INCOMPLETE",
  INCOMPLETE_EXPIRED: "INCOMPLETE_EXPIRED",
  TRIALING: "TRIALING",
  UNPAID: "UNPAID",
} as const;

export type PhoneNumberSubscriptionStatus = (typeof PhoneNumberSubscriptionStatus)[keyof typeof PhoneNumberSubscriptionStatus];

export const SeatChangeType = {
  ADDITION: "ADDITION",
  REMOVAL: "REMOVAL",
} as const;

export type SeatChangeType = (typeof SeatChangeType)[keyof typeof SeatChangeType];

export const ProrationStatus = {
  PENDING: "PENDING",
  INVOICE_CREATED: "INVOICE_CREATED",
  CHARGED: "CHARGED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
} as const;

export type ProrationStatus = (typeof ProrationStatus)[keyof typeof ProrationStatus];

export const CalendarCacheEventStatus = {
  confirmed: "confirmed",
  tentative: "tentative",
  cancelled: "cancelled",
} as const;

export type CalendarCacheEventStatus = (typeof CalendarCacheEventStatus)[keyof typeof CalendarCacheEventStatus];

export const CsgBookingSyncStatus = {
  WRITTEN: "WRITTEN",
  NO_ACCOUNT: "NO_ACCOUNT",
  FAILED: "FAILED",
} as const;

export type CsgBookingSyncStatus = (typeof CsgBookingSyncStatus)[keyof typeof CsgBookingSyncStatus];
